import React from 'react';
import axios from 'axios';
import moment from 'moment';
import { BarChart, XAxis, Tooltip, Bar, Cell, LabelList } from 'recharts';
import { Button, Icon, Table, Header, Popup, Segment, Loader } from 'semantic-ui-react';
import { IconHeader, FiltersOnStyle } from '../../Professor/ProfessorInputGrades/css';
import Filters from './Filters';
import { center, colorss as colors } from '../../Statistics/util';
import {ExportReactCSV} from "../../util/ExportCSV";
import SearchTableData from "../../util/SearchTableData";
import PaginationFront from "../../util/PaginationFront";

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class ExamTermStatistics extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: true,

            results: [],

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],
        };

        this.getDataToRender = this.getDataToRender.bind(this);
        this.getResults = this.getResults.bind(this);

    }

    componentDidMount() {
        let obj = {};
        axios.post(`/exams/statistics/${this.props.location.state.id}`, {})
            .then(res => {
                this.setState({ data: res.data.map(el=>({
                        ...el,
                        examDate: el.examDate ? moment(el.examDate).format('D. M. YYYY.') : '',
                        numberOfStudentsThatAttendedExamI: (parseInt(el.numberOfStudentsThatAttendedExam, 10) / parseInt(el.numberOfStudentsThatRegisteredExam, 10) * 100).toFixed(0) === 'NaN' ? '0 (0)%' : el.numberOfStudentsThatAttendedExam + ' (' + (parseInt(el.numberOfStudentsThatAttendedExam, 10) / parseInt(el.numberOfStudentsThatRegisteredExam, 10) * 100).toFixed(0) + ')' + '%',
                        numberOfStudentsThatPassedExamP: (parseInt(el.numberOfStudentsThatPassedExam, 10) / parseInt(el.numberOfStudentsThatAttendedExam, 10) * 100).toFixed(0) === 'NaN' ? '0 (0)%' : el.numberOfStudentsThatPassedExam + ' (' + (parseInt(el.numberOfStudentsThatPassedExam, 10) / parseInt(el.numberOfStudentsThatAttendedExam, 10) * 100).toFixed(0) + ')' + '%',
                    })), loading: false });
            })
            .catch(err => {
                console.log('Failed to fetch filter results');
            });
    }


    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.data;
    }

    getResults(results) {
        this.setState({ results });
        this.handlePaginationChange({}, {activePage: 1})
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })




    render() {

        const headersForExport = [
            { label: 'Predmet', key: 'courseName' },
            { label: 'Profesor', key: 'professorName' },
            { label: 'Datum ispita', key: 'examDate' },
            { label: 'Broj prijava', key: 'numberOfStudentsThatRegisteredExam' },
            { label: 'Izlaznost', key: 'numberOfStudentsThatAttendedExamI' },
            { label: 'Prolaznost', key: 'numberOfStudentsThatPassedExamP' },
            { label: 'Napomena', key: 'comment' },
        ];

        // Get current posts
        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div>
                <h1>Statistika </h1>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">{this.props.location.state.name}
                        </Header>
                    </Segment>

                    <Segment>
                        <Table celled selectable compact >
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell colSpan={9} >
                                        <span> {this.state.data && <ExportReactCSV color="green" csvData={this.state.data} headers={headersForExport} floated="right" fileName="Statistika na ispitnom roku" />}
                                            <SearchTableData data={this.state.data} getResults={this.getResults} filterItem={['courseName', 'professorName', 'examDate', 'comment']} />
                                        </span>
                                    </Table.HeaderCell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.HeaderCell>Predmet</Table.HeaderCell>
                                    <Table.HeaderCell>Profesor</Table.HeaderCell>
                                    <Table.HeaderCell>Datum ispita</Table.HeaderCell>
                                    <Table.HeaderCell>Prijave <Button circular size="mini" icon="chart bar" floated="right" style={{ backgroundColor: '#046997' }} /></Table.HeaderCell>
                                    <Table.HeaderCell>Izlaznost <Button circular size="mini" icon="chart bar" floated="right" style={{ backgroundColor: '#318db2' }} /></Table.HeaderCell>
                                    <Table.HeaderCell>Prolaznost <Button circular size="mini" icon="chart bar" floated="right" style={{ backgroundColor: '#7ec8db' }} /></Table.HeaderCell>
                                    <Table.HeaderCell>Napomena</Table.HeaderCell>
                                    <Table.HeaderCell colSpan="2" />
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>  {currentPosts.map((el) =>
                                (<Table.Row>
                                    <Table.Cell verticalAlign="middle">
                                        {el.courseName}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.professorName}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.examDate}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" style={{ color: '#046997' }}>
                                        <b>{el.numberOfStudentsThatRegisteredExam}</b>
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" style={{ color: '#318db2' }}>
                                        <b>{el.numberOfStudentsThatAttendedExam}   ({(parseInt(el.numberOfStudentsThatAttendedExam, 10) / parseInt(el.numberOfStudentsThatRegisteredExam, 10) * 100).toFixed(0) === 'NaN' ? '0' : (parseInt(el.numberOfStudentsThatAttendedExam, 10) / parseInt(el.numberOfStudentsThatRegisteredExam, 10) * 100).toFixed(0)}% )       </b>                        </Table.Cell>
                                    <Table.Cell verticalAlign="middle" style={{ color: '#7ec8db' }}>
                                        <b>{el.numberOfStudentsThatPassedExam}    ({(parseInt(el.numberOfStudentsThatPassedExam, 10) / parseInt(el.numberOfStudentsThatAttendedExam, 10) * 100).toFixed(0) === 'NaN' ? '0' : (parseInt(el.numberOfStudentsThatPassedExam, 10) / parseInt(el.numberOfStudentsThatAttendedExam, 10) * 100).toFixed(0)}%)</b>
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.comment}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" colSpan="2">

                                        <BarChart
                                            width={200}
                                            height={80}
                                            style={center}
                                            margin={{ top: 20 }}

                                            data={[
                                                { name: 'prijave', 'broj studenata': el.numberOfStudentsThatRegisteredExam },
                                                { name: 'izlaznost', 'broj studenata': el.numberOfStudentsThatAttendedExam },
                                                { name: 'prolaznost', 'broj studenata': el.numberOfStudentsThatPassedExam },
                                            ]}
                                        >
                                            <XAxis dataKey="name" />
                                            <Tooltip />
                                            <Bar
                                                dataKey="broj studenata"
                                                isAnimationActive
                                            >
                                                {
                                                    [1, 2, 3].map((entry, index) => (
                                                        <Cell key={`cell-${index}`} fill={colors[index]} />
                                                    ))
                                                }
                                                <LabelList dataKey="broj studenata" position="top" fill="#001942" />
                                            </Bar>
                                        </BarChart>
                                    </Table.Cell>
                                </Table.Row>))
                            }
                            </Table.Body>
                        </Table>

                        {currentPosts.length >0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}

                    </Segment>
                </Segment.Group>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamTerms/ExamTermStatistics.js